import React from 'react';
import { WxbIcon } from '../Icon/Icon';
import type { WxbIconName } from '../Icon/icons';
import { WxbEmpty } from '../Empty/Empty';
import './WorkQueue.css';

export interface WxbWorkQueueItem {
  key: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: WxbIconName | React.ReactNode;
  status?: React.ReactNode;
  meta?: React.ReactNode[];
  actions?: React.ReactNode;
}

export interface WxbWorkQueueProps extends React.HTMLAttributes<HTMLDivElement> {
  items: WxbWorkQueueItem[];
  emptyText?: React.ReactNode;
  density?: 'comfortable' | 'compact';
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

const renderIcon = (icon: WxbWorkQueueItem['icon']) => {
  if (!icon) return null;
  if (typeof icon === 'string') return <WxbIcon name={icon} size={18} />;
  return icon;
};

export const WxbWorkQueue: React.FC<WxbWorkQueueProps> = ({
  items,
  emptyText = '暂无待办',
  density = 'comfortable',
  className = '',
  ...props
}) => {
  if (items.length === 0) {
    return <WxbEmpty className={joinClasses('wxb-work-queue-empty', className)} description={emptyText} {...props} />;
  }

  return (
    <div className={joinClasses('wxb-work-queue', `wxb-work-queue-${density}`, className)} {...props}>
      {items.map((item) => (
        <div className="wxb-work-item" key={item.key}>
          {item.icon && <div className="wxb-work-item-icon">{renderIcon(item.icon)}</div>}
          <div className="wxb-work-item-main">
            <div className="wxb-work-item-title-row">
              <div className="wxb-work-item-title">{item.title}</div>
              {item.status && <div className="wxb-work-item-status">{item.status}</div>}
            </div>
            {item.description && <div className="wxb-work-item-description">{item.description}</div>}
            {item.meta && item.meta.length > 0 && (
              <div className="wxb-work-item-meta">
                {item.meta.map((meta, index) => (
                  <span key={index}>{meta}</span>
                ))}
              </div>
            )}
          </div>
          {item.actions && <div className="wxb-work-item-actions">{item.actions}</div>}
        </div>
      ))}
    </div>
  );
};

